<template>
  <div>
    <a-divider v-if="max" class="mt-[16px] -mb-[20px]" />
    <ContentHelpCard
      v-for="(item, index) in max ? data.slice(0, max) : data"
      :key="index"
      :data="item"
      class="mt-[36px] cursor-pointer"
      :words="words"
      :titleLink="goLink(item?.display_title, item)"
      :descLink="goLink(item?.display_content, item)"
      target="_blank"
    >
      <template #other>
        <div class="text-font-50 text-14 mt-[12px]">
          {{ item?.column_title }} | {{ item?.document_name }}
          <span v-if="item.update_time">
            {{ $t('zui-jin-geng-xin') }}
            {{ timeFormat(item?.update_time, 'YYYY-MM-DD HH:mm') }}
          </span>
        </div>
      </template>
    </ContentHelpCard>
  </div>
</template>

<script setup lang="ts">
import { useTime } from '~/hooks/useTime';
import { PageKey } from '~/constants/page';
import type { IHelpSearch } from '~/api/index';
const props = defineProps<{
  data: IHelpSearch[];
  max?: number;
  words: string[];
}>();

const { timeFormat } = useTime();

const goLink = (
  item: { text: string; anchor_point_id: number },
  data: {
    model_type: number;
    model_id: number;
    column_id: number;
  },
) => {
  return {
    name: PageKey.ACADEMY_DETAIL,
    params: {
      collection: `${data?.column_outer_id}-${data?.column_id}`,
      id: `${data.column_id}${data.model_id ? `-${data.model_id}` : ''}`,
    },
    ...(item.anchor_point_id && {
      query: {
        target: item.anchor_point_id,
      },
    }),
  };
};
</script>
